import { ENDPOINT } from '~/api/constants';
import { RequestAPI } from '~/api/Requests';
import type { DestinationKind } from '~/utils/destinationKind';

import type { ETASlotResponse, GetETAProps } from './ETA';
import type { GetETAResponse } from './v3/ETA';

export interface ETARequestsInterface {
  getETA(data: GetETAProps): Promise<{
    data: GetETAResponse;
  }>;

  getETASlot(data: {
    pos: string;
    seller: string;
    scheduleSlotId?: string;
    deliverySlotId?: string;
    createdAt?: number;
    currentDate?: number;
    destinationKind?: DestinationKind;
  }): Promise<ETASlotResponse>;
}

export const ETARequests: ETARequestsInterface = {
  getETA: (data) => {
    const { signal, ...restData } = data;

    return RequestAPI.get(ENDPOINT.eta.get, restData, { signal });
  },
  getETASlot: (data) => RequestAPI.get(ENDPOINT.eta.getSlot, data),
};
